import { RolesEnum, INavbarItem } from '@irembo-andela/irembogov3-common';
import { environment } from '../../../../environments/environment';
export interface ITopNavbarItem extends INavbarItem {
  allowedRoles?: RolesEnum[];
  exactRouteAsActive: boolean;
  iconContent?: string;
}

export const _ITopNavbarItems: Record<string, ITopNavbarItem> = {
  Offices: {
    name: 'Offices',
    routerLink: '/dashboard/users/offices',
    icon: 'fas fa-university',
    exactRouteAsActive: false,
    allowedRoles: [
      RolesEnum.ROLE_OFFICER_ADMIN,
      RolesEnum.ROLE_OFFICER_MANAGER,
    ],
  },
  Users: {
    name: 'Users',
    routerLink: '/dashboard/users/list',
    icon: 'fas fa-users',
    exactRouteAsActive: false,
    allowedRoles: [
      RolesEnum.ROLE_OFFICER_ADMIN,
      RolesEnum.ROLE_OFFICER_MANAGER,
    ],
  },
  Applications: {
    name: 'Inbox',
    routerLink: '/dashboard/services/applications',
    icon: 'fas fa-list',
    exactRouteAsActive: false,
    allowedRoles: [RolesEnum.ROLE_OFFICER],
  },
  AllApplications: {
    name: 'All Applications',
    routerLink: '/dashboard/services/search-applications',
    icon: 'fas fa-magnifying-glass',
    exactRouteAsActive: false,
    allowedRoles: [RolesEnum.ROLE_OFFICER],
  },
  ManagerApplications: {
    name: 'Inbox',
    routerLink: '/dashboard/services/manager-applications',
    icon: 'fas fa-list',
    exactRouteAsActive: false,
    allowedRoles: [RolesEnum.ROLE_OFFICER_MANAGER],
  },
  Reporting: {
    name: 'Reports',
    routerLink: '/dashboard/reporting',
    icon: 'material-icons-round',
    iconContent: 'bar_chart',
    exactRouteAsActive: false,
    allowedRoles: environment.isMetabaseDashboardReportsEnabled
      ? Object.values(RolesEnum)
      : [
          RolesEnum.ROLE_OFFICER_ADMIN,
          RolesEnum.ROLE_OFFICER_MANAGER,
          RolesEnum.ROLE_OFFICER,
        ],
  },
};
